const menuButton = document.getElementById("menuButton");
const menuContactWrap = document.getElementById("js-menu_layer"); // menu_contact_wrapを取得
const menuHeader = document.querySelector(".js-header, .is-header"); // headerを取得
const spMediaQuery = window.matchMedia("(max-width: 768px)");
let isMenuOpened = false;

function openMenu() {
  isMenuOpened = true;
  menuButton.classList.add("is-opened");
  menuContactWrap.classList.add("is-opened"); // menu_contact_wrapにクラスを追加
  if (menuHeader) {
    menuHeader.classList.add("is-opened"); // headerにクラスを追加
  }
}

function closeMenu() {
  isMenuOpened = false;
  menuButton.classList.remove("is-opened");
  menuContactWrap.classList.remove("is-opened"); // menu_contact_wrapのクラスを削除
  if (menuHeader) {
    menuHeader.classList.remove("is-opened"); // headerのクラスを削除
  }
}

function toggleMenu() {
  if (!isMenuOpened) {
    // メニューを開いた時の処理
    openMenu();
  } else {
    // メニューを閉じた時の処理
    closeMenu();
  }
}

menuButton.addEventListener("click", toggleMenu);

spMediaQuery.addEventListener("change", (event) => {
  // SP から PC 幅に切り替わった時、開いているメニューを閉じる
  if (!event.matches && isMenuOpened) {
    closeMenu();
  }
});
